export const brokerUrl = import.meta.env.VITE_MQTTURL || "wss://osmoair-browser:7dd602177460f1644742e155fbeae4ff@mqtts.osmoair.com:8083";
// Publish-only device user — used by the MQTT Publish test widget to simulate a device.
// Separate from the read-only browser connection so the live view stays read-only.
export const devicePublishUrl = import.meta.env.VITE_MQTT_DEVICE_URL || "wss://osmoair-device:bd3ec4a8d959ffdadfb718652c8e1443@mqtts.osmoair.com:8083";
export const topicPrefix = import.meta.env.VITE_NEW_TOPIC_PREFIX!;
// Set before the post-org-switch reload; DashboardPage reads it to hold its loader.
export const ORG_SWITCH_FLAG = "org-switch-pending";
